import type { ChangeEvent } from 'react';

export type DappFormInputChangeEvent =
  | ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  | {
      target: {
        name: string;
        value: unknown;
        type?: string;
      };
    };

export function createSyntheticInputChangeEvent(
  name: string,
  value: unknown,
): DappFormInputChangeEvent {
  return {
    target: {
      name,
      value,
    },
  };
}
